import { createStandardAction } from 'typesafe-actions'
import { InitialView } from '@chegg/one-auth'

export const PAPER_UPLOADED_MODAL = 'PAPER_UPLOADED_MODAL'
export const REVIEWING_PAPER_MODAL = 'REVIEWING_PAPER_MODAL'
export const PAYMENT_MODAL = 'PAYMENT_MODAL'
export const PAPER_UPLOADED_NON_PLUS_MODAL = 'PAPER_UPLOADED_NON_PLUS_MODAL'
export const PLAGIARISM_CHECK_MODAL = 'PLAGIARISM_CHECK_MODAL'
export const CHECK_FAILED_MODAL = 'CHECK_FAILED_MODAL'
export const PLAGIARISM_SOURCES_MODAL = 'PLAGIARISM_SOURCES_MODAL'
export const CONFIRM_LEAVE_MODAL = 'CONFIRM_LEAVE_MODAL'
export const PAPER_SCORECARD_MODAL = 'PAPER_SCORECARD_MODAL'
export const ONE_AUTH_MODAL = 'ONE_AUTH_MODAL'
export const AUTH_MODAL_TITLE = 'Create an account to start your free trial'
// demo work
export const UPLOAD_WIDGET_MODAL = 'UPLOAD_WIDGET_MODAL'
export interface ModalPropsPayloads {
  [CHECK_FAILED_MODAL]: {}
  [PAPER_UPLOADED_MODAL]: {}
  [PAPER_UPLOADED_NON_PLUS_MODAL]: {}
  [PAYMENT_MODAL]: {}
  [PLAGIARISM_CHECK_MODAL]: {}
  [PLAGIARISM_SOURCES_MODAL]: {
    metadataId: string
  }
  [REVIEWING_PAPER_MODAL]: {
    isRecheck: boolean | undefined
  }
  [CONFIRM_LEAVE_MODAL]: {
    navigateToNextLocation?: () => void
  }
  [PAPER_SCORECARD_MODAL]: {
    navigateToExpertCheck?: () => void
    navigateToPlagiarism?: () => void
    navigateToGrammar?: () => void
  }
  [UPLOAD_WIDGET_MODAL]: {
    isResubmit?: boolean
    headingText?: string
    subheadingText?: string
  }
  [ONE_AUTH_MODAL]: {
    view?: InitialView
    origin?: string
    title?: string
  }
}

export type ModalNames = keyof ModalPropsPayloads

export interface ModalPayload<N extends ModalNames> {
  name: N
  modalProps?: ModalPropsPayloads[N]
}

export interface HideModalPayload {
  name: ModalNames
}

export interface ModalMeta {
  origin?: string
}

export const SHOW_MODAL = 'modals/SHOW_MODAL'

export const showModal = createStandardAction(SHOW_MODAL).map(
  ({
    name,
    modalProps,
  }: {
    name: ModalNames
    modalProps?: ModalPropsPayloads[ModalNames]
  }) => ({
    payload: {
      name,
      modalProps: modalProps ? modalProps : {},
    } as ModalPayload<typeof name>,
  })
)

export const HIDE_MODAL = 'modals/HIDE_MODAL'
export const hideModal = createStandardAction(HIDE_MODAL)<HideModalPayload, ModalMeta>()

export const CLEAR_ALL_MODALS = 'modals/CLEAR_ALL_MODALS'
export const clearAllModals = createStandardAction(CLEAR_ALL_MODALS)()



// WEBPACK FOOTER //
// ./src/state/modals/actions.ts